export async function setCookie(name: string, value: string | null, maxAgeSeconds = Infinity): Promise<void> {
	// Chrome caps cookie lifetime at 400 days – the closest thing to Infinity a cookie can express.
	maxAgeSeconds = Math.min(maxAgeSeconds, 60 * 60 * 24 * 400);

	if (typeof cookieStore === "undefined") {
		// Fallback for browsers that don't support the cookie store API
		if (value === null) {
			document.cookie = `${name}=; Max-Age=0; path=/; SameSite=Lax; Secure`;
			return;
		}
		document.cookie = `${name}=${value}; Max-Age=${maxAgeSeconds}; path=/; SameSite=Lax; Secure`;
		return;
	}

	if (value === null) {
		await cookieStore.delete({
			name,
			path: "/",
		});
		return;
	}
	await cookieStore.set({
		name,
		value,
		sameSite: "lax",
		path: "/",
		expires: Date.now() + maxAgeSeconds * 1000,
	});
}
